// import _ from "lodash";
import React, { Fragment, useEffect, useState } from "react";
import Loader from "./Loader";
import useProducts from "../../../hooks/useProducts";
import { useAppSelector } from "../../../app/hooks";
import Emptyshop from "./Emptycart.png";
import ProductCard from "../../../components/ProductCard/ProductCard";
import Show from "../../../components/Show";

type Props = {};

const Products = (props: Props) => {
  const { shop } = useAppSelector((state) => state?.shop);
  // const { country } = useAppSelector((state) => state.app);

  const [searchInput, setSearchInput] = useState<string | null>(
    localStorage.getItem("searchTerm")
  );

  useEffect(() => {
    const storedSearchTerm = localStorage.getItem("searchTerm");
    setSearchInput(storedSearchTerm);
  }, []);

  const { products, loading } = useProducts({
    filter: {
      shop: {
        shop_id: {
          eq: shop?.id,
        },
      },
      // title:{
      //   like:searchInput ?? ""
      // }
      // country: {
      //   eq: country,
      // },
    },
  });

 
  
  return (
    <Fragment>
      <Show if={loading}>
        <Loader />
      </Show>
      <Show if={products.length !== 0}>
        <section
          aria-labelledby="product-heading"
          className="mx-auto max-w-xl px-4 pt-24 sm:px-6 sm:pt-32 lg:max-w-7xl lg:px-8"
        >
          <h2 id="product-heading" className=" mb-8 font-normal text-2xl text-black">
            All products
          </h2>

          <div className=" grid grid-cols-2 gap-4 sm:grid sm:grid-cols-2 sm:mx-6 lg:mx-0 lg:grid lg:grid-cols-4 lg:gap-x-8 lg:space-x-0">
            {products?.map((product, index) => (
              // <div>
                
              <ProductCard product={product} key={index} />
              // </div>
            ))}
          </div>
        </section>
      </Show>
      <Show if={products.length === 0}>
        <div className="flex p-16 flex-col">
          <div className="text-3xl mb-4">Empty shop</div>
          <div className="text-lg">
            Oops, there are no products in this shop at the moment
          </div>
          <div className="m-auto">
            <img src={Emptyshop} alt="empty shop" />
          </div>
        </div>
      </Show>
    </Fragment>
  );
};

export default Products;
